// Central index for all Korean translations
import { authTranslations } from './auth.kr'
import { commonTranslations } from './common'
import { errorTranslations } from './errors'
import { formTranslations } from './forms'
import { protocolTranslations } from './protocol'

export const krTranslations = {
  // Merge all translation modules
  ...authTranslations,
  ...errorTranslations,
  ...formTranslations,
  ...commonTranslations,
  ...protocolTranslations,
}
